import { render, staticRenderFns } from "./picUpload.vue?vue&type=template&id=18ac34f9&scoped=true&"
import script from "./picUpload.vue?vue&type=script&lang=js&"
export * from "./picUpload.vue?vue&type=script&lang=js&"
import style0 from "./picUpload.vue?vue&type=style&index=0&id=18ac34f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac34f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ac34f9')) {
      api.createRecord('18ac34f9', component.options)
    } else {
      api.reload('18ac34f9', component.options)
    }
    module.hot.accept("./picUpload.vue?vue&type=template&id=18ac34f9&scoped=true&", function () {
      api.rerender('18ac34f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/picUpload.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/picUpload.vue
// module id = +pCT
// module chunks = 0